module.exports = __webpack_public_path__ + "static/Project-Loon-Google-35e0c1cefa267af49e9a841177ff811e.png";